var _g;

const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

const SvgPopup = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1294 -696)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1294 696)",
    fill: "#f31c02",
    stroke: "#fff",
    strokeWidth: "2px"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-.627-1.49A.509.509,0,0,1-1-1.644a.509.509,0,0,1-.154-.374V-12.072A.5.5,0,0,1-1-12.457.53.53,0,0,1-.627-12.6H1.2a.509.509,0,0,1,.374.154.509.509,0,0,1,.154.374V-2.018a.509.509,0,0,1-.154.374A.509.509,0,0,1,1.2-1.49ZM-.759,2.8a.509.509,0,0,1-.374-.154.509.509,0,0,1-.154-.374V.182A.5.5,0,0,1-1.133-.2.53.53,0,0,1-.759-.346H1.309a.536.536,0,0,1,.4.154.509.509,0,0,1,.154.374v2.09a.509.509,0,0,1-.154.374.536.536,0,0,1-.4.154Z",
    transform: "translate(1317.714 724.6)"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPopup, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/popup.21440639.svg";
export { ForwardRef as ReactComponent };